import { enableExpandableTextContent } from '@organisms/page-details/enableExpandableTextContent';
import { actions } from '@organisms/offer/actions';

export const initOfferStateModals = () => {
  actions();

  enableExpandableTextContent({
    expandLink: {
      selector: '.offer-description-expander a',
    },
    content: {
      selector: '.offer-description-content',
      expandedClass: 'offer-description-content-expanded',
    },
    section: {
      selector: '.offer-description',
    },
  });
};
